const thumbSlider = new Swiper('.product__thumb-media', {
  direction: 'horizontal',
  slidesPerView: 4,
  spaceBetween: 15,
  breakpoints: {
    1200: {
      direction: 'vertical',
      slidesPerView: 4,
      spaceBetween: 20
    }
  }
});
  const mainSlider = new Swiper('.product__main-media', {
  navigation: {
    nextEl: '.main-media__button--next',
    prevEl: '.main-media__button--prev',
  },
  thumbs: {
    swiper: thumbSlider
  },
  slidesPerView: 1
});

class QuantityController extends HTMLElement {
  constructor() {
    super()
    this.minusButton = this.querySelector('[data-action="minus"]')
    this.plusButton = this.querySelector('[data-action="plus"]')
    this.input = this.querySelector('.quantity-form__input')
    this.min = parseInt(this.input.min) || 1
    this.max = this.input.max ? parseInt(this.input.max) : Infinity
    this.updateButtons()
    this.initEvents()
  }

  updateButtons() {
    let value = parseInt(this.input.value)
    this.minusButton.disabled = value <= this.min
    this.plusButton.disabled = value >= this.max
  }

  initEvents() {
    this.minusButton.addEventListener('click', () => this.changeValue(-1))
    this.plusButton.addEventListener('click', () => this.changeValue(1))
    this.input.addEventListener('input', ()=> {
      if (this.input.value == 0) {
        this.input.value = 1
      }
      this.updateButtons()
    })
  }

  changeValue(step) {
    let newValue = Math.min(Math.max(this.min, parseInt(this.input.value) + step), this.max)
    this.input.value = newValue
    document.querySelector('product-form').updateQuantity(newValue)
    this.updateButtons()
  }
}
customElements.define('quantity-controller', QuantityController);

class ProductForm extends HTMLElement {
  constructor() {
    super()
    this.buyButton = this.querySelector('[type="submit"]')
    this.form = this.querySelector('form')

    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  updateQuantity(newValue){
    this.querySelector('[name="quantity"]').value = newValue
  }

  onSubmitHandler() {
    evt.preventDefault();
    if (this.buyButton.disabled) return;
    const config = fetchConfig('javascript');
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    const formData = new FormData(this.form);
    config.body = formData;
    fetch(`${routes.cart_add_url}`, config)
      .then((response) => response.json())
      .then((data) => {
        // console.log('success');
      })
  }
}
customElements.define('product-form', ProductForm);

class DropdownItem extends HTMLElement {
  constructor() {
    super()
    this.button = this.querySelector('.dropdowns__title');
    this.content = this.querySelector('.dropdowns__content');
    this.arrow = this.querySelector('.dropdowns__title-arrow');
    this.isOpen = false;
    this.button.addEventListener('click', () => this.toggleDropdown());
  }

  toggleDropdown() {
    const allDropdowns = document.querySelectorAll('dropdown-item');
    
    allDropdowns.forEach(dropdown => {
      if (dropdown !== this && dropdown.isOpen) {
        dropdown.closeDropdown();
      }
    });

    this.isOpen ? this.closeDropdown() : this.openDropdown();
  }

  openDropdown() {
    this.isOpen = true;
    this.classList.add('active');
    this.arrow.classList.add('active');
    const contentHeight = this.content.scrollHeight;
    this.content.style.maxHeight = `${contentHeight}px`;
  }

  closeDropdown() {
    this.isOpen = false;
    this.classList.remove('active');
    this.arrow.classList.remove('active');
    this.content.style.maxHeight = '0';
  }
}
customElements.define('dropdown-item', DropdownItem);
class VariantSelects extends HTMLElement {
constructor(){
  super()
  this.addEventListener('change', this.onVariantChange)
}

onVariantChange() {
  this.updateOptions()
  this.getVariantData()
  this.updateForm()
  this.updateMedia()
  this.updateButton()
  this.updatePrice()
  this.updateQuantity()
  this.updateURL()
}

updateOptions() {
  this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
}

getVariantData() {
  this.currentVariant = this.getAllData().find((variant) => {
    return !variant.options
      .map((option, index) => {
        return this.options[index] === option;
      })
      .includes(false);
  });
}

updateForm() {
  const productForm = document.querySelector('product-form')
  const input = productForm.querySelector('input[name="id"]');
  input.value = this.currentVariant.id;
}

updateMedia() {
  if (!this.currentVariant.featured_image) return
  let variantMedia = document.querySelector(`.main-media__image[src="${this.currentVariant.featured_image.src}&width=200"]`)
  document.querySelectorAll('.main-media__image').forEach((image, index) => {
    if (image.src.indexOf(this.currentVariant.featured_image.src) != -1) {
      mainSlider.slideTo(index, 300)     
    }
  })
  if (window.innerWidth <= 768) {
    document.querySelector('.section-product').scrollIntoView({ behavior: "smooth", block: "start"})
  }
}

updateButton() {
  const button = document.querySelector('.product-form__button')
  button.disabled = this.currentVariant.available ? false : true
  button.innerHTML = this.currentVariant.available ? button.dataset.available : button.dataset.soldout
}

updatePrice() {
  let priceElement = document.querySelector('.product__price--common')
  priceElement.innerHTML = Shopify.formatMoney(this.currentVariant.price, theme.moneyFormat)
}

updateQuantity() {
  document.querySelectorAll('[name="quantity"]').forEach(input => {
    input.value = 1
  })
}

getAllData() {
  this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
  return this.variantData;
}

updateURL() {
  window.history.replaceState({}, '', `?variant=${this.currentVariant.id}`);
}
}
customElements.define('variant-selects', VariantSelects);